import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../../Styles/Styles/dashboardstyle.css";
import rightImage from "../../Assets/img/test.png";
import { BASE_URL, security_key } from "../../global";
import LinearProgress from "@mui/material/LinearProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";

const Member_Verify = () => {
    const formRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    // Initially, use the email from location state (first time load)
    const initialEmail = location.state?.user_email || "";
    const [email, setEmail] = useState(initialEmail);  // State to hold email throughout the process

    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [isResending, setIsResending] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formik = useFormik({
        initialValues: {
            user_code: "",
        },
        validationSchema: Yup.object().shape({
            user_code: Yup.string().required("Verification code is required"),
        }),
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            try {
                // Use `email` here (either initial or updated after resend)
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "checkVerificationCode",
                    ...formValues,
                    user_email: email, // Use `email` here, which is updated after resend
                }, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                const output = response.data;
                if (output == 1) {
                    toast.success("Verification successful", {
                        autoClose: 3000,
                    });
                    setTimeout(() => {
                        navigate("/login");
                    }, 3000);
                } else {
                    toast.error("Verification failed, please check the code.", {
                        autoClose: 3000,
                    });
                }
            } catch (error) {
                toast.error("Error occurred. Please try again.", {
                    autoClose: 3000,
                });
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    const sendVerificationCode = async () => {
        if (!email) {
            toast.error("No email found. Please contact support.", {
                autoClose: 3000,
            });
            return;
        }

        toast.dismiss();
        setIsResending(true);

        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "sendVerificationCode",
                user_email: email, // Ensure the email is passed when resending
            });

            const output = response.data;

            if (output == 1) {
                toast.success("Verification code sent to your email", {
                    autoClose: 3000,
                });
            } else {
                toast.error("Failed to resend verification code", {
                    autoClose: 3000,
                });
            }
        } catch (error) {
            toast.error("Error occurred. Please try again.", {
                autoClose: 3000,
            });
        } finally {
            setIsResending(false);
        }
    };

    return (
        <>
            <ToastContainer position="top-center" />

            <section className="bg-1 site-main">
                <div className="container vh-100 d-flex justify-content-center align-items-center">
                    <div className="site-sub-main bg-white">
                        <div className="field d-none d-lg-block bg-1 text-center">
                            <div className="wrapper">
                                <div className="sub-wrapp d-flex align-items-center justify-content-center mt-5">
                                    <div className="text-box-right text-start p-4">
                                        <h2 className="fw-bold fs-3">Verification</h2>
                                        <p className="mb-1">A verification code was sent to your preferred method</p>
                                    </div>
                                </div>
                                <div className="sub-wrapp">
                                    <img src={rightImage} className="img-fluid" width={"529.09px"} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="field d-flex justify-content-center align-items-center flex-column" style={{ height: "520px" }}>
                            <div className="text-header text-center">
                                <h2 className="fw-semibold fs-4 mb-1">Verify</h2>
                                <p className="mx-auto w-md-100 w-75" style={{ fontSize: "16px", fontWeight: "500" }}>
                                    Enter the verification code that was sent to your e-mail
                                </p>

                                <Form className="d-flex align-items-center justify-content-start flex-column" onSubmit={formik.handleSubmit} ref={formRef}>
                                    <div className="input-field mb-18">
                                        <input
                                            type="text"
                                            name="user_code"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.user_code}
                                        />
                                        <label>
                                            Verification Code <span className="text-danger">*</span>
                                        </label>
                                        {formik.errors.user_code && formik.touched.user_code && (
                                            <p className="text-danger text-left f-12">{formik.errors.user_code}</p>
                                        )}
                                    </div>

                                    <Link
                                        to="#"
                                        onClick={() => sendVerificationCode()} // Trigger resend verification
                                        className="text-dark text-start align-items-start mt-2"
                                        style={{ fontSize: "16px", textDecoration: "none" }}
                                    >
                                        <span className="me-1">Didn’t get the code?</span>
                                        <span className="fw-bold fs-6 text-dark text-decoration-underline">
                                            {isResending ? "" : "Resend it"}
                                        </span>
                                    </Link>

                                    <div className="btn-grp mt-3 w-100">
                                        <button type="submit" className="btn btn-dark submit-btn fw-semibold " disabled={isSubmitting}>
                                            {isResending ? "Resending..." : "Verify"}
                                            {isSubmitting && <LinearProgress />}
                                            {isResending && <LinearProgress />}
                                        </button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Member_Verify;
